import { get } from "lodash/object"

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        zIndex: 2,
    },
    content: {
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '0',
    },
}

/**
 * This class is used to create a new item for the list of emails or phone numbers
 * @param {string} value - the type of the item (email or phone number)
 */
class Item {
    constructor(value) {
        this[value] = ''
        this.default = false
        if (value === 'number') {
            this.mobile = false
        }
    }
}

/**
 * Method to bind read-only client data to the request
 * @param {Object} main
 * @param {Object} detail
 * @param {*} clientDictionary
 * @returns {Object} { main, detail } - mapped read-only client data
 */
const formatReadOnlyClientData = (main, detail, clientDictionary) => {
    const readOnlyClientData = { main, detail }

    if (!clientDictionary) {
        return readOnlyClientData
    }

    const personTypeDict = get(clientDictionary, 'personType', [])
    const titleDict = get(clientDictionary, 'title', [])
    const nationalityDict = get(clientDictionary, 'nationality', [])
    const legalFormDict = get(clientDictionary, 'legalForm', [])
    const globalCountryDict = get(clientDictionary, 'globalCountry', [])
    const relationTypeDict = get(clientDictionary, 'relationType', [])
    const genderDict = get(clientDictionary, 'gender', [])

    let clientType = get(main, "clientType", "")
    const clientTypeIndex = personTypeDict.findIndex(({label}) => label === clientType)
    if (clientTypeIndex !== -1) {
        clientType = personTypeDict[clientTypeIndex].value // set value (client type code) instead of label
    }

    let title = get(detail, "title", "")
    const titleIndex = titleDict.findIndex(({label}) => label === title)
    if (titleIndex !== -1) {
        title = titleDict[titleIndex].value // set value (title code) instead of label
    }

    let nationality = get(detail, "nationality", "")
    const nationalityIndex = nationalityDict.findIndex(({label}) => label === nationality)
    if (nationalityIndex !== -1) {
        nationality = nationalityDict[nationalityIndex].value // set value (client nationality code) instead of label
    }

    let legalForm = get(main, "legalForm", "")
    const legalFormIndex = legalFormDict.findIndex(({label}) => label === legalForm)
    if (legalFormIndex !== -1) {
        legalForm = legalFormDict[legalFormIndex].value // set value (legal form code) instead of label
    }

    const correspondanceAddress = get(detail, "correspondanceAddress")
    if (correspondanceAddress) {
        const countryIndex = globalCountryDict.findIndex(({label}) => Object.values(label).includes(correspondanceAddress.country))
        if (countryIndex !== -1) {
            correspondanceAddress.country = globalCountryDict[countryIndex].value // set value (country code) instead of label
        }
    }

    let contacts = get(detail, "contacts", [])
    contacts = contacts.map((contact) => {
        const contactTypeIndex = relationTypeDict.findIndex(({label}) => label === contact.contactType)
        const contactGenderIndex = genderDict.findIndex(({label}) => label.charAt(0) === contact.contactgender.charAt(0))
        if (contactTypeIndex !== -1) {
            contact.contactType = relationTypeDict[contactTypeIndex].value // set value (relation type code) instead of label
        }
        if (contactGenderIndex !== -1) {
            contact.contactgender = genderDict[contactGenderIndex].value // set value
        }
        return contact
    })

    readOnlyClientData.main.clientType = clientType
    readOnlyClientData.detail.title = title
    readOnlyClientData.detail.nationality = nationality
    readOnlyClientData.main.legalForm = legalForm
    readOnlyClientData.main.correnspondanceAddress = correspondanceAddress
    readOnlyClientData.detail.contacts = contacts

    return readOnlyClientData
}

export { customStyles, Item, formatReadOnlyClientData }



// WEBPACK FOOTER //
// ./components/easinsure/client-profile/client-profile-form/helpers.js